import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';

import { ProjectSelectorComponent } from './project-selector.component';
import { UserManualDirective } from '../../shared/user-manual/user-manual.directive';

@NgModule({
  imports: [CommonModule, MatSelectModule, UserManualDirective],
  declarations: [ProjectSelectorComponent],
  exports: [ProjectSelectorComponent],
})
export class ProjectSelectorModule {}
